// Accordion toggle for the Home services pillars.
// Visual animation is CSS-driven (grid-template-rows 0fr→1fr); this just
// flips data-open + ARIA state and keeps the closed panel out of the focus
// order via `inert`.

export default function services() {
    const toggles = document.querySelectorAll('[data-services-toggle]');
    if (toggles.length === 0) return;

    const setOpen = (button, open) => {
        const pillar = button.closest('.services__pillar');
        const body = document.getElementById(button.getAttribute('aria-controls'));
        pillar.dataset.open = String(open);
        button.setAttribute('aria-expanded', String(open));
        if (!body) return;
        if (open) {
            body.removeAttribute('aria-hidden');
            body.removeAttribute('inert');
        } else {
            body.setAttribute('aria-hidden', 'true');
            body.setAttribute('inert', '');
        }
    };

    toggles.forEach((button) => {
        setOpen(button, false);

        button.addEventListener('click', () => {
            const pillar = button.closest('.services__pillar');
            const willOpen = pillar.dataset.open !== 'true';

            // Only one pillar open at a time — collapse the rest before
            // opening this one (a second open closes the previous).
            if (willOpen) {
                toggles.forEach((other) => {
                    if (other !== button) setOpen(other, false);
                });
            }
            setOpen(button, willOpen);
        });
    });
}
